import { useEffect } from 'react';
import { useRouter } from 'next/router';
import useSWR from 'swr';
import { Button, Image, Text } from '@belong/ui';

export default function MaintenancePage() {
  const router = useRouter();

  const { data, isValidating, mutate } = useSWR(
    '/api/maintenance-windows',
    async () => {
      const res = await fetch('/api/maintenance-windows');

      if (!res.ok) {
        return null;
      }

      return res.json();
    },
    { refreshInterval: 30000 },
  );

  useEffect(() => {
    if (Array.isArray(data) && data.length === 0) {
      router.replace('/');
    }
  }, [data, router]);

  function handleCheck() {
    mutate();
  }

  return (
    <div className="px-sm flex min-h-screen flex-col items-center justify-center text-center">
      <Image
        src="https://belong-web-assets.s3-us-west-2.amazonaws.com/belong_home_maintenance_2x.png"
        alt="Belong Home maintenance illustration"
        className="max-h-[400px] w-auto"
        lazy={false}
      />
      <Text as="h1" variant="h2" fontWeight="semibold" className="mt-lg">
        We&apos;ll be back soon!
      </Text>
      <Text className="mt-sm max-w-prose">
        Just like we do for the homes we care for, we&apos;re currently
        performing a bit of preventative maintenance on our site. We&apos;ll be
        back online shortly! In the meantime, feel free to{' '}
        <a
          href="mailto:hello@belonghome.com"
          className="font-semibold no-underline"
        >
          CONTACT US
        </a>
        .
      </Text>
      <div className="mt-lg w-full max-w-xs">
        <Button onClick={handleCheck} disabled={isValidating}>
          {isValidating ? 'Checking…' : "Check if we're back"}
        </Button>
      </div>
    </div>
  );
}
